import { useState } from 'react';

const faqItems = [
  {
    question: 'po文推荐的内容是如何筛选的？',
    answer: '我们的编辑团队每天从海量内容中精选出高质量的文章，筛选标准包括内容原创性、专业深度、实用价值和读者反馈。同时结合大数据分析，确保推荐的内容兼具品质与热度。',
  },
  {
    question: 'po文推荐清单多久更新一次？',
    answer: '我们的推荐清单每日更新，确保您每次访问都能发现新鲜优质的内容。热门榜单每小时刷新一次，精选合集每周更新，节假日还会有特别策划的主题推荐专题。',
  },
  {
    question: '如何收藏和分享喜欢的po文？',
    answer: '在每篇文章页面底部，我们提供了收藏和分享功能。您可以一键收藏到个人书签，也可以通过社交媒体、微信或复制链接的方式与朋友分享你喜欢的内容。',
  },
  {
    question: 'po文推荐支持哪些内容类型？',
    answer: '目前我们的推荐涵盖内容创作、写作技巧、阅读方法、创作工具、内容变现、创作者生活等多个领域。我们会持续拓展内容类型，覆盖更多创作者关心的主题，让每一位读者都能找到感兴趣的内容。',
  },
  {
    question: '如何成为po文推荐的达人作者？',
    answer: '如果您有优质的内容创作能力，欢迎通过"关于我们"页面的联系方式与我们取得联系。我们的编辑团队会评估您的内容质量和风格匹配度，通过后会邀请您加入达人作者计划，享受专属推荐位和流量扶持。',
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <section className="py-14 md:py-20 bg-background-100/70">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              常见问题
            </h2>
            <p className="text-sm text-foreground-500 mt-2">关于po文推荐的常见疑问解答</p>
          </div>

          <div className="space-y-3">
            {faqItems.map((item, index) => (
              <div
                key={index}
                className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
              >
                <button
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                >
                  <span className="text-sm font-medium text-foreground-800 pr-4">
                    {item.question}
                  </span>
                  <div className={`w-6 h-6 flex-shrink-0 flex items-center justify-center transition-transform duration-200 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}>
                    <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
                  </div>
                </button>
                {openIndex === index && (
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}